import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmModal } from '@cashfree-intl/coherent';

export function RemovePopup({ onCloseClick, onConfirmClick, value }) {
  return (
    <ConfirmModal
      danger
      title="Delete Preference"
      onClose={onCloseClick}
      onConfirm={onConfirmClick}
      confirmText="Delete"
      confirmBtnEvent="Danger_Button_Delete_Preference_Confirm"
      closeBtnEvent="Link_Button_Delete_Preference_Cancel"
      closeCrossEvent="Delete_Preference_Icon_Close"
    >
      Are you sure you want to delete this preference ({value})?
    </ConfirmModal>
  );
}

RemovePopup.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default RemovePopup;
